import { __classPrivateFieldGet } from '../../node_modules/tslib/tslib.es6.js';
import { SDKResource } from '../../client/client.js';

// AUTOGENERATED -- DO NOT EDIT
var _Telemed_instances, _Telemed_baseUrlThunk;
class Telemed extends SDKResource {
    constructor(config) {
        super(config);
        _Telemed_instances.add(this);
    }
    /**
     * Create a [telemedicine video meeting](https://docs.oystehr.com/oystehr/services/telemed/).
     *
     * Access Policy Requirements:
     * Action: `Telemed:CreateMeeting`
     * Access Policy Resource: `Telemed:Meeting`
     * Action: `FHIR:Create`
     * Access Policy Resource: `FHIR:Encounter`
     * Action: `FHIR:Update`
     * Access Policy Resource: `FHIR:Encounter`
     */
    createMeeting(params, request) {
        return this.request('/telemed/v2/meeting', 'post', __classPrivateFieldGet(this, _Telemed_instances, "m", _Telemed_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Get Meeting and Attendee objects necessary to join a telemedicine video meeting.
     *
     * Access Policy Requirements:
     * Action: `Telemed:JoinMeeting`
     * Access Policy Resource: `Telemed:Meeting`
     * To use M2M token to join as anonymous user:
     * Action: `Telemed:AddAnonymousToMeeting`
     * Access Policy Resource: `Telemed:Meeting`
     */
    joinMeeting(params, request) {
        return this.request('/telemed/v2/meeting/{encounterId}/join', 'get', __classPrivateFieldGet(this, _Telemed_instances, "m", _Telemed_baseUrlThunk).bind(this))(params, request);
    }
}
_Telemed_instances = new WeakSet(), _Telemed_baseUrlThunk = function _Telemed_baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['projectApiUrl']) !== null && _b !== void 0 ? _b : 'https://project-api.zapehr.com/v1';
};

export { Telemed };
//# sourceMappingURL=telemed.js.map
